"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgChartPieFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30 16a14 14 0 00-3.21-8.91l-9.39 9.39 6.16 11.29A14 14 0 0030 16zM25.4 5.65a14 14 0 00-8.4-3.6v12zM15 2.05A14 14 0 002.05 15H15zM2.05 17A14 14 0 0021.8 28.73L15.41 17z" })));
}
exports.default = SvgChartPieFilled;
//# sourceMappingURL=ChartPieFilled.js.map